import { find, isEmpty } from 'lodash';

export const operatorsForQuestionType = {
  NPS: {
    positive: '>= 9',
    negative: '< 6',
    positiveText: ['Promoter', '9-10'],
    negativeText: ['Detractor', '0-6'],
    all: '> 7',
    allText: ['Passive', '7-8'],
  },
  StarRating: {
    positive: '>= 4',
    negative: '< 4',
    positiveText: ['Positive', '4-5 stars'],
    negativeText: ['Negative', '1-3 stars'],
  },
  FCR: {
    positive: '== 1',
    negative: '== 0',
    positiveText: ['Resolved'],
    negativeText: ['Not resolved'],
  },
  Recovery: {
    positive: '== 1',
    negative: '== 0',
    positiveText: ['Recovered'],
    negativeText: ['Not recovered'],
  },
};

export const makeCondition = (
  movedQuestion,
  questionConditial,
  experienceType
) => {
  const experienceTypeFromQuestion =
    movedQuestion.type === 'AreasOfImprovement' ? 'negative' : 'positive';
  const operatorPart =
    operatorsForQuestionType[questionConditial.type][
      experienceType || experienceTypeFromQuestion
    ];

  // wrap in quotes for new-question-id lookups
  return `answers['${questionConditial.id}'].value ${operatorPart}`;
};

// unwrap question-id
const conditionToQuestionId = condition => {
  const [idPart, operatorPart, valuePart] = condition.split(' ');

  const pattern = new RegExp(/\[(.+)\]/);
  const matchResult = pattern.exec(idPart)[1];
  const questionId = matchResult.replace(/'/g, '');

  return [
    Number(questionId) || questionId,
    `${operatorPart} ${Number(valuePart)}`,
  ];
};

export const translationTextToQuestionId = translationText => {
  // '{% if answers[].value %}...{% endif %}' -> 'answers[].value'
  const pattern = new RegExp(/\{% if (.+?) %\}/);
  const matchResult = pattern.exec(translationText);
  if (!matchResult) return [];

  return conditionToQuestionId(matchResult[1]);
};

export const questionAndOptionFromCondition = (question, questions) => {
  if (!question || !question.condition) return {};

  try {
    const [conditionalQuestionId, operatorValuePart] = conditionToQuestionId(
      question.condition
    );
    const conditionalQuestion = find(
      questions,
      q =>
        q.id === Number(conditionalQuestionId) ||
        q.id === conditionalQuestionId
    );

    if (conditionalQuestion) {
      const firstValidConditionalOption = conditionalQuestion.options.find(

        option => eval(`${option.integer_value} ${operatorValuePart}`)
      );

      return {
        question: conditionalQuestion,
        option: firstValidConditionalOption,
      };
    }
  } catch (e) {
    // condition format not in answers[question_id].value > option_value
  }
  return {};
};

export const questionAndOptionParamsFromCondition = (question, questions) => {
  // questionAndOptionFromCondition wrapper to extract ids for use as query parameters
  const questionAndOption = questionAndOptionFromCondition(question, questions);
  if (isEmpty(questionAndOption)) return {};

  return {
    question: questionAndOption.question.id,
    option: questionAndOption.option.id,
  };
};
